import React from 'react';
import './CustomLoader.css';

const CustomLoader = () => {
  return (
    <div className="custom-loader">
      <div className="loader-content">
        {/* Company Logo */}
        <div className="logo-container">
          <img 
            src="/img/img-icon/logo_xinchuan.png" 
            alt="XinChuan Logo" 
            className="company-logo"
          />
        </div>
        
        {/* Welcome Text */}
        <div className="welcome-text">
          <h1 className="welcome-title">Welcome to XinChuan</h1>
          <p className="welcome-subtitle">Interior Design Excellence</p>
        </div>
        
        {/* Loading Animation */}
        <div className="loading-animation">
          <div className="loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
      </div>
      
      {/* Background Lines */}
      <div className="background-lines">
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
    </div>
  );
};

export default CustomLoader; 